import type { PolicySlot, VideoType, Weekday } from '@shared/types.ts'

/** 番組表に出す種別の日本語ラベル */
export const VIDEO_TYPE_LABELS: Record<VideoType, string> = {
  'music-video': 'MV',
  live: 'ライブ',
  interview: 'インタビュー',
  talk: 'トーク',
  radio: 'ラジオ',
  documentary: 'ドキュメンタリー',
  other: 'その他',
}

export const videoTypeLabel = (type: VideoType): string => VIDEO_TYPE_LABELS[type] ?? 'その他'

/** 曜日の日本語ラベル */
export const WEEKDAY_LABELS: Record<Weekday, string> = {
  mon: '月',
  tue: '火',
  wed: '水',
  thu: '木',
  fri: '金',
  sat: '土',
  sun: '日',
}

/** 編成方針の枠の時間帯。例: 0:00-6:00 */
export const slotRangeLabel = (slot: PolicySlot): string =>
  `${slot.startHour}:00-${slot.endHour}:00`
